import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconNotEligibleFilledSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M3.667 26.663h1.911l6.459-22.608.058-.155A1 1 0 0 1 13 3.33h6l.164.013a1 1 0 0 1 .797.712l6.46 22.608h1.913a1 1 0 0 1 0 2H3.667a1 1 0 1 1 0-2m18.958-6-1.143-4H10.514l-1.142 4zm-10.968-8h8.682l-1.143-4H12.8z" clipRule="evenodd" /></svg>;
export default SvgIconNotEligibleFilledSmall;